import { render, staticRenderFns } from "./MonitorBrandButton.vue?vue&type=template&id=44ddbf14&scoped=true&"
import script from "./MonitorBrandButton.vue?vue&type=script&lang=ts&"
export * from "./MonitorBrandButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ddbf14",
  null
  
)

export default component.exports